export default __webpack_public_path__ + "static/media/Download_Que.a15730ae.svg";